import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ConfirmAdvise({
  open,
  handleClose,
  message = "",
  heading = "",
  isLoading = false,
  adviseMe = false,
  selectedTags,
  setCurrentStep,
  dynamicOptions = {}
}) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => handleClose("cancel")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="text-blue-600">
          {heading}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>

          <div className="grid md:grid-cols-2 gap-4 my-2">
            <div className="w-full Key">
              <span className="text-[#414651] text-[14px] sm:text-[16px]">
                {t(`firstFormSteps.weight.label`)}
              </span>
              <input
                type="text"
                className="border p-2 pl-3 rounded-md w-full bg-gray-100 cursor-not-allowed h-10"
                value={selectedTags?.weight}
                readOnly
              />
            </div>
            <div className="w-full Key">
              <span className="text-[#414651] text-[14px] sm:text-[16px]">
                {t(`firstFormSteps.height.label`)}
              </span>
              <div className="relative">
                <input
                  type="text"
                  className="border p-2 pl-3 pr-10 rounded-md w-full bg-gray-100 cursor-not-allowed h-10"
                  value={selectedTags?.height}
                  readOnly
                />
              </div>
            </div>

            <div className="w-full Key">
              <span className="text-[#414651] text-[14px] sm:text-[16px]">
                {t(`firstFormSteps.yourAge.label`)}
              </span>
              <input
                type="text"
                className="border p-2 pl-3 rounded-md w-full bg-gray-100 cursor-not-allowed h-10"
                value={selectedTags?.yourAge}
                readOnly
              />
            </div>

            <div className="w-full Key">
              <span className="text-[#414651] text-[14px] sm:text-[16px]">
                {t(`firstFormSteps.activity.label`)}
              </span>
              <input
                type="text"
                className="border p-2 pl-3 rounded-md w-full bg-gray-100 cursor-not-allowed h-10"
                value={t(`firstFormSteps.activity.options.${selectedTags?.activity}`)}
                readOnly
              />
            </div>
            <div className="w-full Key">
              <span className="text-[#414651] text-[14px] sm:text-[16px]">
                {t(`firstFormSteps.weightGoal.label`)}
              </span>
              <input
                type="text"
                className="border p-2 pl-3 rounded-md w-full bg-gray-100 cursor-not-allowed h-10"
                // value={selectedTags?.weightGoal}
                value={t(`firstFormSteps.weightGoal.options.${selectedTags?.weightGoal}`)}
                readOnly
              />
            </div>
            <div className="w-full Key">
              <span className="text-[#414651] text-[14px] sm:text-[16px]">
                {t(`firstFormSteps.gainMuscle.label`)}
              </span>
              <input
                type="text"
                className="border p-2 pl-3 rounded-md w-full bg-gray-100 cursor-not-allowed h-10"
                // value={selectedTags?.gainMuscle}
                value={t(`firstFormSteps.gainMuscle.options.${selectedTags?.gainMuscle}`)}
                readOnly
              />
            </div>
          </div>
          <div className="flex justify-end">
            {adviseMe? (
              <p
                onClick={() =>
                  navigate("/edit-preferences", { state: { slideToShow: 1 } })
                }
                className="text-blue-600 underline hover:text-blue-800 text-[14px] cursor-pointer"
              >
                {t(`firstFormSteps.editYourInfoText`)}
              </p>
            ):
            <p
            onClick={() =>{
                setCurrentStep(2);
                handleClose("cancel");
            }
                
            }
            className="text-blue-600 underline hover:text-blue-800 text-[14px] cursor-pointer"
          >
           {t(`firstFormSteps.editYourInfoText`)}
          </p>
            }
          </div>
        </DialogContent>

        <DialogActions>
          <button
            onClick={() => handleClose("cancel")}
            autoFocus
            disabled={isLoading}
            className={`px-4 py-1 bg-white text-[red] rounded-md border border-[red] text-[14px] ${
              isLoading && "opacity-[0.7] pointer-events-none"
            }`}
          >
            {t(`firstFormSteps.confirmAdvisebuttonCancelText`)}
          </button>
          <button
            onClick={() => handleClose("confirm")}
            autoFocus
            disabled={isLoading}
            className={`px-4 py-1 bg-blue-600 text-white rounded-md border border-blue-600 text-[14px] ${
              isLoading
                ? "opacity-[0.7] pointer-events-none"
                : "hover:bg-white hover:text-[#0575E6]"
            }`}
          >
            {t(`firstFormSteps.confirmAdvisebuttonText`)}
          </button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
